<div mat-dialog-content>
  <div class="flex flex-col gap-4">
    <span class="f-s-20"> Mark Payment Paid</span>
    <form [formGroup]="paymentForm" (ngSubmit)="savePayment()" class="pt-4">
      <div class="flex flex-col gap-2 md:gap-6">
        <mat-form-field>
            <mat-label>Payment Paid</mat-label>
            <input formControlName="paymentCleared"
                   placeholder="mm/dd/yyyy"
                   matInput
                   [matDatepicker]="datepickerPaymentCleared"
                   [max]="today"/>
            <mat-datepicker-toggle matSuffix [for]="datepickerPaymentCleared"></mat-datepicker-toggle>
            <mat-datepicker #datepickerPaymentCleared>
              <mat-datepicker-actions>
                <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                <button mat-button matDatepickerCancel>Cancel</button>
              </mat-datepicker-actions>
            </mat-datepicker>
            <mat-error *ngIf="paymentForm.get('paymentCleared').hasError('required')">
              A paid date is required
            </mat-error>
            <mat-error *ngIf="paymentForm.get('paymentCleared').value > today">
              Please choose an earlier date.
            </mat-error>
          </mat-form-field>
        <div class="flex flex-row gap-4 mt-4 portal-actions">
          <button *ngIf="paymentForm.get('paymentCleared').value <= today && paymentForm.valid"
                  mat-raised-button type="button" color="primary" [disabled]="processing"
                  (click)="savePayment()">Mark as Paid
          </button>
          <button mat-raised-button type="button" color="warn" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>
